import React from 'react'

import { podDetail, tudoDetail } from 'constants/card-details'
import {
    Background,
    Content,
    Header,
    Info,
    Name,
    Text,
    Title
} from './DetailProductHeader.style'
import DetailProductForm from './DetailProductForm'

const DetailProductHeader = ({ type, data }) => {
    const info = {
        TUDO: tudoDetail,
        POD: podDetail
    }

    const product = { ...data, ...info[type] }

    return (
        <>
            <Header $color={product.backgroundColor}>
                <Content>
                    <Info>
                        <Name>{product.name}</Name>
                        <Title $gradient={product.gradient}>
                            {product.title}
                        </Title>
                        <Text>{product.subtitle}</Text>
                    </Info>
                    <DetailProductForm product={product} />
                </Content>
            </Header>
            <Background $bgImage={product.background} />
        </>
    )
}

export default DetailProductHeader
